<bs-linear-module-container
    [expandable]="true"
    [defaultExpanded]="defaultExpanded"
    [trackingBetslipTypeContext]="betslipType"
    (expandedChanged)="toggleExpand($event)">
    <ng-template [bsLinearModuleHeader]>
        <div class="teaser-bet-linear__teaser-info">
            <span class="teaser-bet-linear__title">{{ sitecore.betslip.linear.TeasersHeader }}</span>
        </div>
    </ng-template>
    <ng-template [bsLinearModuleContent]>
        <div class="teaser-bet-linear_teaser-module-content">
            <bs-linear-container-errors [betslipType]="betslipType" />
            <bs-teaser-bet-container [isLinear]="true" [oddsDisplayFormat]="oddsDisplayFormat" />
        </div>
    </ng-template>
</bs-linear-module-container>
